import { Injectable } from '@angular/core';
import { WebsocketService } from './websocket.service';
import { ModalResultsServicesService } from './modal-results-services.service';
import { LoaderService } from './loader.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionService {
  public pageTitle: string = '';
  userName: string = "";
  userId: string = "";
  srno: number = 0;
  caseProcsessingState: number = 0;

  uploadedFileName: string = "";
  
  DocCaseHeaderId: number = 0;
  id: number = 0;
  clientpdfpath: string = "";
  itrpdfpath: string = "";
  UserId: number = 0;
  servivngLocationId: any;
  
  filesToProcess : {[key:string]: string} = {};
  uId: string = '';

  processedFileCount = 0;
   progress$ = new Subject<{
    total: number;
    fileName: string;
  }>();
  

  constructor(public webSocket:WebsocketService, private modalResult: ModalResultsServicesService, private loaderSer: LoaderService) {

  // webSocket.ITRJsonEvent.subscribe((data:any) => {
  //   if(data['uuId'] === this.uId) {
  //     switch (data['type']) {
  //       case 'P' : 
  //             this.loaderSer.hideProcessingToaster();
  //             this.filesToProcess[data['fileName']] = 'In Process';
  //             this.loaderSer.showProcessingToaster(`Processing File: ${data['fileName']}`, `${(Object.keys(this.filesToProcess)).findIndex((x:any) => x === data['fileName']) + 1} Out Of ${(Object.keys(this.filesToProcess)).length}`)
  //             break;
  //       case 'C' : 
  //           // this.loaderSer.hideProcessingToaster();
  //           this.filesToProcess[data['fileName']] = data['Data']['ackNo'];
  //           this.modalResult.itrZipJsonResult.push(data['Data']);
  //           const filesArray = Object.keys(this.filesToProcess); 
    
  //           if(filesArray[filesArray.length - 1] === data['fileName']) {
  //             this.modalResult.disabledStartProcessButton = false;
  //             this.loaderSer.hideProcessingToaster();
  //           }
            
  //           break;    
  //     }
  //   }
  // })
  // }
 
    webSocket.ITRJsonEvent.subscribe((data: any) => {
      if (data['uuId'] === this.uId) {
        switch (data['type']) {
          case 'P':
            this.filesToProcess[data['fileName']] = 'In Process';
            this.emitProgress(data['fileName']);
            break;

          case 'C':
            ++this.processedFileCount;
            // Bug 1 fix: error 'C' events carry { error: true } — skip pushing to results
            if (!data['Data']?.error) {
              this.filesToProcess[data['fileName']] = data['Data']['ackNo'];
              this.modalResult.itrZipJsonResult.push(data['Data']);
            }
            this.emitProgress(data['fileName']);

            // when last file processed
            const filesArray = Object.keys(this.filesToProcess);
            if (filesArray[filesArray.length - 1] === data['fileName']) {
              this.modalResult.disabledStartProcessButton = false;
            }
            break;
          }
        }
      });
    }


  private emitProgress(fileName: string) {
    const total = Object.keys(this.filesToProcess).length;
    
    this.progress$.next({ total, fileName });
  };

   CreateObjectForFilesToProcess = (data:any) => {
    this.filesToProcess = {};

    this.uId = data['uuId'];
    this.processedFileCount = 0;

    for (const fileName of data['extractedFiles']) {
      this.filesToProcess[fileName] = "";
    }
  }


  restrictCharacters(str: string) {
    const invalidChars = ["<", ">", "~", "\\", "-", "+", "e"];

    return invalidChars.includes(str);
  }

  itrAPIResult = {};
  statusDropdownJson:any = {};

  formatNumber(num: number): string {
    return num.toLocaleString('en-IN');
  }

  getIncomeRange(income: number): string {
    if (income < 0) return "Income should be positive.";
    if (income > 5000000) {
      const lowerBound = income - 300000;
      const upperBound = income + 300000;
      return `between Rs.${this.formatNumber(lowerBound)} to Rs.${this.formatNumber(upperBound)}`;
    }
  
    const base = 200000;
    const lowerBound = Math.floor(income / base) * base;
    const upperBound = lowerBound + base;
  
    return `between Rs.${this.formatNumber(lowerBound)} to Rs.${this.formatNumber(upperBound)}`;
  }
 
  getTaxRange(taxPaid: number): string {
    if (taxPaid < 0) return "Tax paid should be positive.";
    const base = 200000;
    const lowerBound = Math.floor(taxPaid / base) * base;
    const upperBound = lowerBound + base;
    return `between Rs.${this.formatNumber(lowerBound)} to Rs.${this.formatNumber(upperBound)}`;
  }
  
  formatYearRange(yearRange: string): string {
    if (!yearRange || !yearRange.includes('-')) {
      return yearRange;
    }
    const parts = yearRange.split('-');
    const firstYear = parts[0].trim(); // "2022"
    const secondYearShort = parts[1].trim(); // "23"

    const century = firstYear.substring(0, 2);
    const secondYearFull = `${century}${secondYearShort}`;

    return `${firstYear} - ${secondYearFull}`;
  }

}
